export const hasNullRequiredField = (row: any, requiredFields: string[]) => {
  for (const key of requiredFields) {
    if (key === "receipt" || key === "delivery") {
      if (!row[key] || (!row[key].wId && !row[key].value)) {
        return true;
      }
    } else if (row[key] === null || row[key] === undefined) {
      return true;
    }
  }

  return false;
};

export const toPath = (key: string | string[]) => {
  if (Array.isArray(key)) return key.map(String).filter(Boolean);
  return String(key)
    .split(/[.,]/g)
    .map((item) => item.trim())
    .filter(Boolean);
};

export const setDeepImmutable = (obj: any, path: string[], value: any) => {
  if (!path.length) return obj;

  const next = { ...(obj || {}) };
  let current: any = next;

  for (let i = 0; i < path.length; i++) {
    const key = path[i];
    const isLast = i === path.length - 1;

    if (isLast) {
      current[key] = value;
    } else {
      const prev = current[key];
      current[key] =
        typeof prev === "object" && prev !== null ? { ...prev } : {};
      current = current[key];
    }
  }

  return next;
};

export const normalizeTouchedKey = (key: string | string[]) =>
  Array.isArray(key) ? key.join(".") : String(key);
